import { ButtonsWrapper } from "./FilterComponents/styles";

interface FilterActionsProps {
  onClear: () => void;
}

export const FilterActions = ({ onClear }: FilterActionsProps) => (
  <ButtonsWrapper>
    <button type="button" className="grid-history-action-btn" onClick={onClear}>
      Limpar
    </button>
    <button type="submit" className="grid-history-action-btn grid-history-action-btn--primary">
      Aplicar
    </button>
  </ButtonsWrapper>
);
